import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 hero-mesh">
      <div className="text-center max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 mb-10">
          <img
            src="/assets/images/Busigrow_Registered-1751003166599.png"
            alt="BusiGrow Logo"
            className="h-14 w-auto object-contain"
          />
        </Link>

        <h1 className="text-8xl font-black text-violet-600">404</h1>
        <h2 className="mt-4 text-2xl font-bold text-slate-900">Page not found</h2>
        <p className="mt-2 text-slate-500">
          This page doesn't exist. Let's get you back on track.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl glass text-slate-700 text-sm font-medium hover:bg-white/70 transition-all"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </button>
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl bg-gradient-to-r from-violet-600 to-purple-600 text-white text-sm font-medium hover:shadow-apple-lg transition-all"
          >
            <Home className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
